import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { AuthProvider } from "@/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import RestaurantPublic from "@/pages/RestaurantPublic";
import OrderSuccess from "@/pages/OrderSuccess";
import MyOrders from "@/pages/MyOrders";
import OrderTracking from "@/pages/OrderTracking";
import SuperAdmin from "@/pages/SuperAdmin";
import SuperAdminLogin from "@/pages/SuperAdminLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Legal from "@/pages/Legal";
import CookieBanner from "@/components/CookieBanner";

function AppRouter() {
  const location = useLocation();
  const navigate = useNavigate();
  // Customer guard: a logged-in customer must NEVER land on landing/login/register/dashboard/super-admin.
  // They have separate flows (storefronts + my-orders + my-order tracking only).
  useEffect(() => {
    const customerToken = localStorage.getItem("foodgo_customer_token");
    const restaurateurToken = localStorage.getItem("foodgo_token");
    if (customerToken && !restaurateurToken) {
      const forbidden = ["/", "/login", "/register", "/dashboard", "/super-admin", "/sa-login", "/forgot-password", "/reset-password"];
      if (forbidden.includes(location.pathname)) {
        const lastSlug = localStorage.getItem("foodgo_last_slug");
        navigate(lastSlug ? `/r/${lastSlug}` : "/my-orders", { replace: true });
      }
    }
  }, [location.pathname, navigate]);
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/sa-login" element={<SuperAdminLogin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/super-admin" element={<SuperAdmin />} />
      <Route path="/r/:slug" element={<RestaurantPublic />} />
      <Route path="/r/:slug/success" element={<OrderSuccess />} />
      <Route path="/my-orders" element={<MyOrders />} />
      <Route path="/my-order/:oid" element={<OrderTracking />} />
      <Route path="/privacy" element={<Legal doc="privacy" />} />
      <Route path="/cookies" element={<Legal doc="cookies" />} />
      <Route path="/terms" element={<Legal doc="terms" />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}
function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <CookieBanner />
          </AuthProvider>
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
